import { serviceShortCodes } from "../configs/serviceShortCodes";
import { CategoryResponse } from "../typings/interfaces/responses/category-response";

/**
 * Invoice prefix for a bill (e.g. "DC" -> DC26-123). The service's invoice
 * code from Price Setup wins; the old hard-coded map is the fallback. Services
 * added later (Fur, Leather & Suede, Carpets & Rugs) were missing from that
 * map, so their bills were sent without a code and failed.
 */
export const serviceInvoiceCode = (
  service: CategoryResponse | undefined,
  categories: CategoryResponse[] | undefined
): string => {
  const configured = categories?.find((c) => c.id === service?.id)?.categoryCode ?? service?.categoryCode;
  const code =
    configured?.trim() ||
    serviceShortCodes[service?.categoryName as keyof typeof serviceShortCodes];
  if (!code) {
    throw new Error(
      `"${service?.categoryName ?? "This service"}" has no invoice code. Set it in Admin > Price Setup > Edit Service.`
    );
  }
  return code;
};
